import React from 'react';

import Date from '../../../Types/Components/Date';
import CardHOC from './Components/CardHOC';

const DateType = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <Date question={question} />
  </CardHOC>
}

export default DateType;